export { initializeIcons } from '@fluentui/font-icons-mdl2';

// eslint-disable-next-line @typescript-eslint/no-deprecated
export type { IconNames } from '@fluentui/font-icons-mdl2';
